import { render } from "./HikiatekinSetting.vue?vue&type=template&id=461e7304&ts=true"
import script from "./HikiatekinSetting.vue?vue&type=script&lang=ts"
export * from "./HikiatekinSetting.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__